export default {
  methods: {
    deviceIsOffline(system) {
      try {
        let latestSystemTimestamp = this.$moment(system.timestamp);
        let now = this.$moment(new Date(), 'YYYY-MM-DDTHH:mm:ssZ');
        let timeDiff = this.$moment.duration(now.diff(latestSystemTimestamp));
        /**
         * Change timeout from 60 to 75
         * Same value as IOS/Android
         * Update: 12/11/2020
         */
        return timeDiff.asSeconds() > 75;
      } catch (error) {
        this.$log.error('OverviewErrorOfflineHandler::deviceIsOffline():', error);
      }
    },

    /** Error yes / no */
    deviceHasErrors(systemStatus) {
      /**
       * TODO: provide proper documentation
       * Hint: we only use the bitmask for showing possible errors
       * on the diamond. The bitmask is not used in combination with the expertview
       * or system page.
       */
      const bitmask = 0x3410200;
      const systemError = systemStatus;
      return (systemError & bitmask) !== 0;
    },

    /** Live values yes / no */
    deviceHasNoLiveValues(pv, charge, grid, mode) {
      // check no value or obslete value
      switch (mode) {
        case 'allDiamondValues':
          return (
            pv === (undefined || null) &&
            charge === (undefined || null) &&
            grid === (undefined || null)
          );
        case 'pvDiamondValue':
          return pv === (undefined || null);
        case 'chargeDiamondValue':
          return charge === (undefined || null);
        case 'gridDiamondValue':
          return grid === (undefined || null);
        default:
          return false;
      }
    },

    /** Live values older than 60 seconds yes / no */
    deviceHasObsoleteLiveValues(applicationTimestamp) {
      const obsleteTime = 60;
      let now = this.$moment(new Date(), 'YYYY-MM-DDTHH:mm:ssZ');
      let timestampToCheck = applicationTimestamp;

      let nowUTC = this.$moment.utc(now).format('YYYY-MM-DD[T]HH:mm:ssZ');
      let timestampToCheckUTC = this.$moment.utc(timestampToCheck).format('YYYY-MM-DD[T]HH:mm:ssZ');

      let timeDiff = new Date(nowUTC).getSeconds() - new Date(timestampToCheckUTC).getSeconds();
      // let timeDiff = Math.floor(Math.random() * 70) + 61
      return timeDiff > obsleteTime;
    },

    deviceHasObsoleteCalculatedValues(resultPV, resultCharge, resultGrid) {
      return resultPV && resultCharge && resultGrid;
    }
  }
};
